import Panel from './component'

export default Panel
